import styles from "./myAccount.module.css";

export const myAccountStyle = {
  container: `flex flex-col w-full gap-6 py-6 rounded-md container relative ${styles.container}`,
  error_page: `w-full text-center bg-liveGameBackground rounded-md backdrop-filter backdrop-blur-[12.5px]`,
  image: `mx-auto h-[350px]`,
  signUp: `hidden md:flex justify-end text-[14px] w-[68%] max-w-[100%] gap-1 ml-auto text-end ${styles.signUp} `,
  link: `cursor-pointer text-primaryGold`,
  selectivetabcontent: `hidden md:flex flex-col w-[270px] max-w-full ${styles.selectivetabcontent}`,
  home_team_info: `flex items-center gap-[5px] self-center
                   sm:gap-[6px] sm:self-end`,
  team_text: `text-[14px] font-[400] text-primaryHeading ${styles.team_text}`,
  home_team_icon: `max-w-[20px] w-full h-auto ${styles.home_team_icon}`,
  team_name: `font-[400] text-[14px]
              sm:font-[500] `,
};
